import { render, staticRenderFns } from "./editDepartment.vue?vue&type=template&id=e7c68ff8&scoped=true"
import script from "./editDepartment.vue?vue&type=script&lang=js"
export * from "./editDepartment.vue?vue&type=script&lang=js"
import style0 from "./editDepartment.vue?vue&type=style&index=0&id=e7c68ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c68ff8",
  null
  
)

export default component.exports